module.exports = __webpack_public_path__ + "static/media/radar.8bcd7725.svg";